export const API_URL = process.env.REACT_APP_API_URL || '/api';
export const DELEGON_URL = process.env.DELEGON_URL || 'https://delegon.com';
